<template>
  <div>
    <Nav class="nav" />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Footer from '@/components/Footer.vue'
export default {
  components: {
    Nav,
    Footer
  }
}
</script>

<style scoped>
.nav{
  position: sticky;
  top: 0;
  z-index: 1001;
}
</style>
